import * as T from "react";
import { useUtils as C } from "./useUtils.mjs";
import d from "./useEventCallback.mjs";
import R from "./useControlled.mjs";
const I = ({
  timezone: i,
  value: s,
  defaultValue: c,
  onChange: o,
  valueManager: e
}) => {
  var u, m;
  const t = C(), z = T.useRef(c), n = (u = s ?? z.current) != null ? u : e.emptyValue, l = T.useMemo(() => e.getTimezone(t, n), [t, e, n]), p = d((r) => l == null ? r : e.setTimezone(t, l, r)), f = (m = i ?? l) != null ? m : "default", h = T.useMemo(() => e.setTimezone(t, f, n), [e, t, f, n]), V = d((r, ...a) => {
    const W = p(r);
    o?.(W, ...a);
  });
  return {
    value: h,
    handleValueChange: V,
    timezone: f
  };
}, b = ({
  name: i,
  timezone: s,
  value: c,
  defaultValue: o,
  onChange: e,
  valueManager: u
}) => {
  const [m, t] = R({
    name: i,
    state: "value",
    controlled: c,
    default: o ?? u.emptyValue
  }), z = d((n, ...l) => {
    t(n), e?.(n, ...l);
  });
  return I({
    timezone: s,
    value: m,
    defaultValue: void 0,
    onChange: z,
    valueManager: u
  });
};
export {
  b as useControlledValueWithTimezone,
  I as useValueWithTimezone
};
//# sourceMappingURL=useValueWithTimezone.mjs.map
